import {
	GET_PRODUCT_SUCCESS,
	GET_PRODUCT_FAIL,
	CLEAR_PRODUCTS,
} from '../actions/index';

const initialState = {
	products: [],
	error: null,
	loading: true,
};

const storeReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_PRODUCT_SUCCESS: {
			const newProducts = Array.isArray(action.payload.prodData)
				? action.payload.prodData
				: [action.payload.prodData];

			const updatedProducts = [
				...state.products,
				...newProducts.filter(
					(newProduct) =>
						!state.products.some(
							(existingProduct) =>
								existingProduct.product_id === newProduct.product_id
						)
				),
			];

			return {
				...state,
				products: updatedProducts,
				error: null,
				loading: false,
			};
		}
		case GET_PRODUCT_FAIL:
			return {
				...state,
				products: [],
				error: action.payload,
				loading: false,
			};
		case CLEAR_PRODUCTS:
			return {
				...state,
				products: [],
				count: 0,
				loading: false,
			};
		default:
			return state;
	}
};

export default storeReducer;
